import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { relocateWidget } from "../../api";
import { relocateZoneWidget } from "../../redux";
import { Alert } from "../";
import { withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";

const MoveWidgetComp = (props) => {
  const { t } = useTranslation();
  const { zone, toggleMove } = props;
  const dispatch = useDispatch();
  const dashboardZones = useSelector(
    (state) => state.dashboardZones.dashboardZones
  );
  const [zoneIndex, setZoneIndex] = useState();
  const [zoneId, setZoneId] = useState();
  const token = Cookies.get("token");
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });

  const zoneClicked = (value, index) => {
    setZoneIndex(index);
    setZoneId(value.id);
  };

  const relocateWidgetClicked = () => {
    const data = new FormData();
    data.append("serial", zone.serial);
    data.append("widget", zone.id);
    data.append("zone", zoneId);
    relocateWidget(data, token)
      .then(() => {
        setShowAlert((prevState) => ({
          ...prevState,
          show: true,
          message: t("ویجت با موفقیت منتقل شد."),
          type: "Success",
        }));
        setTimeout(() => {
          setShowAlert((prevState) => ({
            ...prevState,
            show: false,
          }));
          toggleMove();
          dispatch(relocateZoneWidget(zone));
        }, 2000);
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
            type: "Error",
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              ...prevState,
              show: false,
            }));
          }, 2000);
        }
      });
  };

  return (
    <div className="text-right">
      <div className="d-flex justify-content-center my-3">
        <div>
          <i className="circleTop icon-plug text-center m-auto"></i>
          <div className="text-center mt-2">
            <p className="m-0">{t("انتقال به")}</p>
            <small className="text-muted-left">{zone.caption}</small>
          </div>
        </div>
        <span
          onClick={relocateWidgetClicked}
          className="d-block changeRoomCheck bg-white cursor rounded-circle position-absolute"
        ></span>
      </div>
      <div className="my-4" style={{ minHeight: "40vh" }}>
        {dashboardZones?.map((zone, index) => {
          let active = zoneIndex === index ? "selectRoomsActive" : "";
          return (
            <div
              className={`selectRooms text-center py-3 my-2 cursor ${active}`}
              key={index}
              onClick={() => zoneClicked(zone, index)}
            >
              <p className="m-0 fn">{zone.zone_caption}</p>
            </div>
          );
        })}
      </div>
      {showAlert.show && (
        <Alert message={showAlert.message} type={showAlert.type} />
      )}
    </div>
  );
};

const MoveWidget = withRouter(MoveWidgetComp);

export { MoveWidget };
